import { useContactSectionContent } from './useContactSectionContent';
import { parseContactSpeakContent } from '../utils/contactContent';

export const useContactSpeakContent = () => useContactSectionContent(parseContactSpeakContent);
